import 'primeicons/primeicons.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "flowbite";
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './Screens/HomesPage/HomePage';
import Login from './Screens/Auth/Login';
import EditablePortfolio from './Screens/Portfolio/EditablePortfolio';
import UploadScreen from './Screens/UploadScreen/UploadScreen';
import SharedPortfolio from './Screens/Portfolio/SharedPortfolio';
import PasswordReset from './Screens/Auth/PasswordReset';
import ContactUs from './Screens/ContactUs';
import FindFundi from './Screens/FindFundi';
import FindHarware from './Screens/FindHardware';
import FindRental from './Screens/FindRental';
import DotDot from './Screens/DotDot';
import TandC from './Components/Terms&Conditions/TandC';
import Error404 from './Screens/404/Error404';
import AboutUsPage from './Screens/AboutUs/AboutUs';
import FAQPage from './Screens/Faqs/faqs';
import Subscribe from './Screens/Subscribe/Subscribe';
import SubscribeComplete from './Screens/Subscribe/SubscribeComplete';
import MetaPixelRouteTracker from './Components/MetaPixelRouteTracker';
import { MemberAuthProvider } from './Database/RekebishaMembers/MemberAuthContext';

function App() {
  return (
    // Site-wide "is a visitor signed in as a member" state, used to gate contact
    // details / reviews on the Find Fundi and Find Rental pages — separate from the
    // fundi-portfolio-owner login used by /login and /editableportfolio.
    <MemberAuthProvider>
      <Router>
        <MetaPixelRouteTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/editableportfolio" element={<EditablePortfolio />} />
          <Route path="/uploadscreen" element={<UploadScreen />} />
          <Route path="/find-fundi/shared/:sharedId" element={<SharedPortfolio />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/contact-us" element={< ContactUs />} />
          <Route path="/find-fundi" element={< FindFundi />} />
          <Route path="/find-hardware" element={< FindHarware />} />
          <Route path="/find-rental" element={< FindRental />} />
          <Route path="/dot-dot" element={<DotDot />} />
          <Route path="/terms-and-conditions" element={<TandC/>} />
          <Route path="/faqs" element={<FAQPage/>} />
          <Route path="/subscribe/:fundiId" element={<Subscribe />} />
          <Route path="/subscribe/complete" element={<SubscribeComplete />} />
          <Route path="/*" element={<Error404/>} />
        </Routes>
      </Router>
    </MemberAuthProvider>
  );
}

export default App;
